import { createContext, useContext } from "react";
import { STRINGS } from "./strings";

export const LANG_KEY = "encraft-lang";

export const LangContext = createContext("en");

export const useLang = () => useContext(LangContext);
export const useT = () => STRINGS[useContext(LangContext)];
